export function buildChannelSummary(channelLabels: string[], language: string): string {
  const listFormatter = new Intl.ListFormat(language, { style: 'long', type: 'conjunction' });
  return listFormatter.format(channelLabels);
}
